import { all, call, fork, put, takeLeading } from "typed-redux-saga";
import { Action, changePasswordActions } from "./change-password-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { LoginService } from "src/backend/openapi/v1";

export function* changePassword(action: ReturnType<typeof changePasswordActions.PostChangePasswordRequest>) {
  try {
    const result = yield* call(LoginService.postApiV1LoginChangePassword, undefined, action.payload.data);
    if (!result.succeeded) throw result.errorList;
    yield put(changePasswordActions.PostChangePasswordSuccess(result));
    action.payload.callback(true);
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(changePasswordActions.PostChangePasswordFail());
    action.payload.callback(false);
  }
}

export function* changePasswordWatch() {
  yield takeLeading(Action.PostChangePasswordRequest, changePassword);
}

export function* changePasswordSaga() {
  yield all([fork(changePasswordWatch)]);
}
